import { ChevronDownIcon, ChevronUpIcon } from '@approvalmax/ui';
import { Button, Grid, Label, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import { useToggle } from 'react-use';

import { messages } from './EntityDetails.messages';
import { EntityDetailsProps } from './EntityDetails.types';

export const EntityDetails = memo<EntityDetailsProps>((props) => {
    const { mainDetail, additionalDetails = [] } = props;

    const [isExpanded, toggleExpanded] = useToggle(false);
    const hasMainDetail = Boolean(mainDetail);
    const hasAdditionalDetails = additionalDetails.length > 0;

    if (!hasMainDetail && !hasAdditionalDetails) return null;

    return (
        <Grid gap={8}>
            {hasMainDetail && (
                <div>
                    <Label size='xsmall'>{mainDetail?.label}</Label>

                    <Text font='label' fontSize='xsmall'>
                        {mainDetail?.value}
                    </Text>
                </div>
            )}

            {hasAdditionalDetails && (!hasMainDetail || isExpanded) && (
                <>
                    {additionalDetails.map((detail, index) => (
                        <div key={index}>
                            <Label size='xsmall'>{detail.label}</Label>

                            <Text font='label' fontSize='xsmall'>
                                {detail.value}
                            </Text>
                        </div>
                    ))}
                </>
            )}

            {hasMainDetail && hasAdditionalDetails && (
                <div>
                    <Button
                        size='xsmall'
                        color='blue10'
                        noUppercase
                        endIcon={isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
                        onClick={toggleExpanded}
                        tabIndex={-1}
                    >
                        {isExpanded ? messages.collapse : messages.showMore}
                    </Button>
                </div>
            )}
        </Grid>
    );
});

EntityDetails.displayName = 'EntityDetails';
